import React from 'react';
import { PartnerType } from 'Enums';
import { Main, TitleActionBar } from 'Components/utility';
import { cutString } from 'Utilities/dataHelpers';
import mediator from 'Utilities/mediator';
import InboundApi from './InboundApi';
import PartnerApi from './PartnerApi';
import Redox from './Redox';
const PartnerConnection = ({ data: { partnerConnection } }) => {
    if (!partnerConnection ||
        !Object.values(PartnerType).includes(partnerConnection.partner.type)) {
        mediator.publish('router:navigate', '/connections');
        return;
    }
    const type = partnerConnection.partner.type;
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { testID: "PartnerConnection", title: cutString(partnerConnection.partner.name, 20), closeBtn: true }),
        {
            [PartnerType.InboundApi]: React.createElement(InboundApi, { partnerConnection: partnerConnection }),
            [PartnerType.Redox]: React.createElement(Redox, { partnerConnection: partnerConnection }),
            [PartnerType.PartnerApi]: React.createElement(PartnerApi, { partnerConnection: partnerConnection }),
        }[type] ??
            (() => {
                mediator.publish('router:navigate', '/connections');
                return null;
            })()));
};
export default PartnerConnection;
